import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { pageAtom, isAuthAtom, customAvatarAtom, myNftBackAtom } from '../../State';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { ReactComponent as BackAddSVG } from '../Images/buttons/backAddButton.svg';
import { ReactComponent as MyAvatarIconSVG } from '../Images/buttons/myAvatarIcon.svg';
import KUTE from 'kute.js';
import './NFT.css';
import 'react-loading-skeleton/dist/skeleton.css';
import NFTItem from './NFTItem';
import { useTranslation } from 'react-i18next';
import { storage } from '../Util/Firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { ReactComponent as BackArrowSVG } from '../Images/buttons/backArrow.svg';
import { ReactComponent as UploadingSVG } from '../Images/buttons/uploadingButton.svg';
import { getImagePath } from '../Util/utils';
import { isMobile } from 'react-device-detect';
import isElectron from '../../Global';
import DataModel from '../Util/DataModel';

export default function NFTOriginal({ setNftType }) {
  const callObject = useDaily();
  const localSessionId = useLocalSessionId();

  //Recoil系
  const [myNftBackState, setNftBackState] = useRecoilState(myNftBackAtom);
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const { t } = useTranslation();

  //その他
  const inputFileRef = useRef(null);
  const [stepState, setStepState] = useState(null);
  const [uploadingState, setUploadingState] = useState(null);
  const [myCustomBackground, setMyCustomBackground] = useState(null);
  const [emailState, setEmailState] = useState(null);
  const [imageURLState, setImageURLState] = useState(null);

  //初期化
  useEffect(() => {
    //データ取得
    getData();
  }, []);

  async function getData() {
    const result = await DataModel.getMyCustomBackground();

    if (result != null) {
      console.log(result);
      if (result.patternID != null) {
        setMyCustomBackground(result.patternID);
      }
    } else {
      setMyCustomBackground(null);
    }
  }

  //写真選択
  const selectPic = async (e) => {
    if (isAuthState == false) {
      alert('You need login');
      return;
    }

    const { files } = e.target;
    let file = files[0];

    //ファイルサイズチェック
    if (file.size > 10000000) {
      alert('File size should be less than 10MB');
      return;
    }

    //タイプチェック
    if (file.type == 'image/png' || file.type == 'image/jpeg') {
    } else {
      alert('Only Jpeg and PNG format are accepted');
      return;
    }

    //ステータス変更
    setUploadingState('uploading');

    //UUID取得
    let uuid;
    try {
      let uuidResult = await DataModel.getUUID();
      if (uuidResult != null) {
        uuid = uuidResult.uuid;
      }
    } catch (e) {
      console.log(e);
    }

    //名前の変更
    let name = 'original' + uuid + '.' + file.name.split('.').pop();

    const storageRef = ref(storage, `/original/${name}`);

    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100); // update progress
        console.log(percent);
      },
      (err) => setUploadingState(null),
      async () => {
        //        setNftBackState(name);

        //データベースに保存
        let result = await DataModel.saveOriginal(name);

        if (result != null) {
          //ステータス変更
          setEmailState(result.email);
          setImageURLState(result.imageURL);
          setUploadingState('completed');
        } else {
          setUploadingState(null);
        }
      },
    );
  };

  //ボディータイプを選択
  const tapBackArrow = async (status) => {
    if (status == '2') {
      setStepState('price');
    } else {
      setStepState(null);
    }
  };

  //ボディータイプを選択
  const tapNext = async (status) => {
    setStepState('price');
  };

  //背景リストの表
  return (
    <>
      {stepState == null && (
        <>
          {/*背景一覧 */}
          <div className="nftListTitle4">{t('nft.Original Avatar')}</div>
          <div className="nftOriginalBody">{t('nft.Convert your...')}</div>
          <div className="nftOriginalImage">
            {/* <img src={getImagePath() + '/icons/nftoriginalbanner.png'} /> */}

            <video
              src={getImagePath() + '/video/originalSample2.mp4'}
              autoPlay
              muted
              loop
              playsInline></video>
          </div>
          <div className="nftOriginalCheckWrap">
            <div className="nftOriginalCheckItem">
              <img src={getImagePath() + '/icons/roundCheck.svg'} />
              <div>{t('nft.A professional animator will handle the animation.')}</div>
            </div>

            <div className="nftOriginalCheckItem">
              <img src={getImagePath() + '/icons/roundCheck.svg'} />
              <div>{t('nft.Supports various 2D images(Portrait, Characters, etc).')}</div>
            </div>

            <div className="nftOriginalCheckItem">
              <img src={getImagePath() + '/icons/roundCheck.svg'} />
              <div>{t('nft.Low price and quick delivery.')}</div>
            </div>
          </div>
          <button
            className="nftOriginButton"
            onClick={() => {
              setStepState('price');
            }}>
            {t('nft.More detail')}
          </button>
        </>
      )}

      {stepState == 'price' && (
        <>
          <div id="nftListTitle">
            <BackArrowSVG onClick={tapBackArrow} />
            <div>{t('nft.Make your original avatar')}</div>
          </div>
          <div className="nftListTitle4"> {t('nft.Price & deliver time')}</div>
          <div className="nftOriginalBody">{t('nft.Price and delivery time...')}</div>

          <div className="nftOriginalPriceWrap">
            <div className="nftOriginalPriceItem">
              <img src={getImagePath() + '/icons/price1.png'} />
              <div className="nftOriginalPriceText">
                $199 <span>({t('nft.3 days')})</span>{' '}
              </div>
            </div>
            <div className="nftOriginalPriceItem">
              <img src={getImagePath() + '/icons/price2.png'} />
              <div className="nftOriginalPriceText">
                $299 <span>({t('nft.5 days')})</span>{' '}
              </div>
            </div>
            <div className="nftOriginalPriceItem">
              <img src={getImagePath() + '/icons/price3.png'} />
              <div className="nftOriginalPriceText">
                $399 <span>({t('nft.7 days')})</span>{' '}
              </div>
            </div>
          </div>

          <div className="nftOriginal3dWrap">
            <img src={getImagePath() + '/icons/no3d.png'} />
            <div className="nftOriginalLeft">
              <div className="nftOriginal3dTitle">{t('nft.3D is not supported')}</div>
              <div className="nftOriginal3dBody">{t('nft.3D images...')}</div>
            </div>
          </div>

          <button
            className="nftOriginButton"
            onClick={() => {
              setStepState('upload');
            }}>
            {t('nft.Apply now')}
          </button>
        </>
      )}

      {stepState == 'upload' && (
        <>
          <div id="nftListTitle">
            <BackArrowSVG onClick={() => tapBackArrow('2')} />
            <div>{t('nft.Make your original avatar')}</div>
          </div>
          {/* <div className="nftListTitle4"> Upload an image</div>
          <div className="nftOriginalBody">PNG or JPEG image is supported (max size is 5MB)</div> */}
          <div style={{ textAlign: 'center' }}>
            {/* 写真選択 */}
            {uploadingState == null && (
              <>
                <div className="myAvatarTitleWrap">
                  <div className="myAvatarTitleLeft">
                    <div className="myAvatarTitle">{t('nft.Select image')}</div>
                    <div className="myAvatarDetail">
                      {t('nft.Please select PNG or JPEG format image (max 5MB)')}
                    </div>
                  </div>
                </div>
                <div id="myAvatarPictureArea">
                  <MyAvatarIconSVG />
                </div>
                <input
                  ref={inputFileRef}
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={selectPic}
                />
                <button id="myAvatarButton" onClick={() => inputFileRef.current?.click()}>
                  {t('nft.Select image')}
                </button>
              </>
            )}

            {/* 画像をアップロード中 */}
            {uploadingState == 'uploading' && (
              <>
                <div id="myAvatarPictureArea">
                  <div id="myAvatarPictureUploading">
                    <UploadingSVG />
                  </div>

                  <div className="myAvatarUploading">{t('nft.Uploading...')}</div>
                </div>
              </>
            )}

            {/* 画像をアップロード完了 */}
            {uploadingState == 'completed' && (
              <>
                <div className="nftOriginalCompleteImage">
                  <img src={imageURLState} />
                </div>
                <div className="nftOriginalCompleteTitle"> {t('nft.Sent successfully!')}</div>
                <div className="nftOriginalCompleteBody">
                  {t('nft.We will reply your email address below.')}
                </div>
                <div className="nftOriginalCompleteEmail">{emailState}</div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
}
